
.intro {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .header {
    max-width: 680px;

    h1 {
      font-size: 1.85rem;
      font-weight: 600;
      line-height: 1.2;
      margin: 0 0 .5rem;
    }
  }

  .eyebrow {
    display: inline-block;
    margin-bottom: .5rem;
    font-size: .75rem;
    font-weight: 600;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: var(--primary);
  }

  .lead {
    font-size: 1.05rem;
    line-height: 1.7;
    margin: 0;
  }

  .outro {
    margin: 0;
    color: var(--gray);
  }
}
